import React from "react";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Button from "components/base/Button";
import LoadingComponent from "../Btn/components/LoadingComponent";
import BtnContent from "../Btn/components/BtnContent";

// ** Custom Styles
import { resolveProps, marginable } from "styles/styledComponentsMixins";
import { useSelector } from "react-redux";

// #####################################################

const StyledButtonLanding = styled(({ ...props }) => (
	<Button {...resolveProps(props, marginable)} />
))(({ $outline, $isModal, $authModalVersion }) => {
	return css`
		position: relative;
		display: inline-block;
		cursor: pointer;
		white-space: normal;
		text-wrap: nowrap;
		text-align: center;
		font-size: 1.1rem;
		line-height: 2rem;
		padding: 0 1rem;
		height: 42px;
		width: 100%;
		border-radius: var(--dz-sys-button-landing-border-radius);
		background-color: var(--dz-sys-button-landing-background-color);
		color: var(--dz-sys-button-landing-text-color);
		box-shadow: var(--dz-sys-auth-panel-shadow);
		border: 1px solid var(--dz-sys-button-landing-background-color-hover);

		${marginable.css}

		&:hover {
			background-color: var(
				--dz-sys-button-landing-background-color-hover
			);
		}

		&:active {
			background-color: var(
				--dz-sys-button-landing-background-color-active
			);
		}

		&:disabled {
			&:hover,
			&:active {
				background-color: var(--dz-sys-button-landing-background-color);
			}
		}

		${$isModal &&
		$authModalVersion === "darkAndLight" &&
		css`
			box-shadow: ${({ theme: { isDarkMode } }) =>
				isDarkMode
					? "var(--dz-sys-auth-panel-shadow)"
					: "0 1px 2px 0 rgb(0 0 0 / 0.6),0 1px 2px -1px rgb(0 0 0 / 0.6)"};
		`}

		${$outline &&
		css`
			color: var(--dz-sys-button-landing-outline-text-color);
			background-color: var(
				--dz-sys-button-landing-outline-background-color
			);
			border: 1px solid
				var(--dz-sys-button-landing-outline-background-color-hover);

			&:hover {
				background-color: var(
					--dz-sys-button-landing-outline-background-color-hover
				);
			}

			&:active {
				background-color: var(
					--dz-sys-button-landing-outline-background-color-active
				);
			}

			${$isModal && $authModalVersion === "darkAndLight"
				? css`
						background-color: transparent;
						color: var(--dz-sys-text-color);
						border: ${({ theme: { isDarkMode } }) =>
							isDarkMode
								? "1px solid var(--dz-sys-button-landing-outline-background-color-hover)"
								: "1px solid var(--dz-sys-text-color)"};
						box-shadow: ${({ theme: { isDarkMode } }) =>
							isDarkMode
								? "var(--dz-sys-auth-panel-shadow)"
								: "0 1px 2px 0 rgb(0 0 0 / 0.6),0 1px 2px -1px rgb(0 0 0 / 0.6)"};
						&:hover,
						&:active {
							color: var(--dz-sys-text-color-always-light);
						}
				  `
				: $isModal &&
				  css`
						background-color: transparent;
						color: var(--dz-sys-button-landing-outline-text-color);

						&:hover,
						&:active {
							color: var(--dz-sys-text-color-always-light);
						}
				  `}
		`}
	`;
});

// #####################################################

export const ButtonLanding = ({
	label,
	children,
	loading,
	$isModal,
	...rest
}) => {
	const textContent = children || label;

	// ** A/B Tests
	const authModalVersion = useSelector(
		(state) => state.globalCommon.authModal.version
	);

	// #####################################################

	return (
		<StyledButtonLanding
			{...rest}
			$isModal={$isModal}
			$authModalVersion={authModalVersion}
		>
			{loading ? (
				<LoadingComponent alwaysLight />
			) : (
				<BtnContent textContent={textContent} />
			)}
		</StyledButtonLanding>
	);
};

// #####################################################
